import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = '/api/';
import { Container, Typography, TextField, Button, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, IconButton, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const ChaPanelaDesejos = () => {
  const [desejos, setDesejos] = useState([]);
  const [item, setItem] = useState('');
  const [recebido, setRecebido] = useState(false);
  const [doador, setDoador] = useState('');
  const [editId, setEditId] = useState(null);

  const fetchDesejos = async () => {
    const res = await axios.get(`${API_URL}cha_panela_desejos`);
    setDesejos(res.data);
  };

  useEffect(() => {
    fetchDesejos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}cha_panela_desejos/${editId}`, { item, recebido, doador });
    } else {
      await axios.post(`${API_URL}cha_panela_desejos`, { item, recebido, doador });
    }
    setItem('');
    setRecebido(false);
    setDoador('');
    setEditId(null);
    fetchDesejos();
  };

  const handleEdit = (desejo) => {
    setItem(desejo.item);
    setRecebido(!!desejo.recebido);
    setDoador(desejo.doador || '');
    setEditId(desejo.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`/api/cha_panela_desejos/${id}`);
    fetchDesejos();
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Lista de Desejos</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <TextField
            label="Item desejado"
            value={item}
            onChange={e => setItem(e.target.value)}
            required
          />
          <Checkbox
            checked={recebido}
            onChange={e => setRecebido(e.target.checked)}
            inputProps={{ 'aria-label': 'Recebido?' }}
          /> Recebido
          {recebido && (
            <TextField
              label="Nome do doador"
              value={doador}
              onChange={e => setDoador(e.target.value)}
              placeholder="Quem deu o presente?"
            />
          )}
          <Button type="submit" variant="contained" color="primary">
            {editId ? 'Salvar' : 'Adicionar'}
          </Button>
          {editId && (
            <Button variant="outlined" color="secondary" onClick={() => { setEditId(null); setItem(''); setRecebido(false); setDoador(''); }}>
              Cancelar
            </Button>
          )}
        </form>
      </Paper>
      <Table component={Paper}>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            <TableCell>Recebido</TableCell>
            <TableCell>Doador</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {desejos.map(desejo => (
            <TableRow key={desejo.id}>
              <TableCell>{desejo.item}</TableCell>
              <TableCell>
                <Checkbox checked={!!desejo.recebido} disabled />
              </TableCell>
              <TableCell>{desejo.doador || '-'}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleEdit(desejo)}><EditIcon /></IconButton>
                <IconButton onClick={() => handleDelete(desejo.id)} color="error"><DeleteIcon /></IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
};

export default ChaPanelaDesejos;
